import { TApisOfSchemas } from '../..';
import type ISchemas from './schemas';

const apis: TApisOfSchemas<ISchemas> = {
  getPellekanUrl: () => ({
    url: `webview/api/v1/Generate/url/Pellekan`,
    method: 'GET',
  }),
};

export default apis;
